
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 2.25c-5.376 0-9.75 4.374-9.75 9.75s4.374 9.75 9.75 9.75 9.75-4.374 9.75-9.75S17.376 2.25 12 2.25zm0 18c-4.549 0-8.25-3.701-8.25-8.25 0-4.549 3.701-8.25 8.25-8.25 4.549 0 8.25 3.701 8.25 8.25 0 4.549-3.701 8.25-8.25 8.25zm3.691-10.924c.263 1.497-.373 2.84-1.79 3.781-.941.625-1.146 1-1.19 1.133a.75.75 0 01-1.422-.48c.213-.632.779-1.236 1.782-1.902.929-.617 1.302-1.36 1.142-2.272A2.25 2.25 0 009.749 10a.75.75 0 01-1.5 0c0-1.111.488-2.158 1.34-2.873a3.767 3.767 0 013.084-.818c1.512.265 2.753 1.506 3.018 3.017zM13 17a1 1 0 11-2 0 1 1 0 012 0z","fill":"currentColor"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/lk/icons/question-circle.svg